import { Component, OnInit, HostListener } from '@angular/core';

interface Country {
  code: string;
  dialCode: string;
  flag: string;
  name: string;
}

@Component({
  selector: 'app-private-label',
  templateUrl: './private-label.component.html',
  styleUrls: ['./private-label.component.scss']
})
export class PrivateLabelComponent implements OnInit {
  mobileNumber: string = '';
  selectedCountry: Country;
  showCountryDropdown: boolean = false;
  selectedCountryForm: string = 'SA';
  showCountryFormDropdown: boolean = false;

  countries: Country[] = [
    { code: 'SA', dialCode: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
    { code: 'AE', dialCode: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
    { code: 'KW', dialCode: '+965', flag: '🇰🇼', name: 'Kuwait' },
    { code: 'QA', dialCode: '+974', flag: '🇶🇦', name: 'Qatar' },
    { code: 'BH', dialCode: '+973', flag: '🇧🇭', name: 'Bahrain' },
    { code: 'OM', dialCode: '+968', flag: '🇴🇲', name: 'Oman' },
    { code: 'EG', dialCode: '+20', flag: '🇪🇬', name: 'Egypt' },
    { code: 'JO', dialCode: '+962', flag: '🇯🇴', name: 'Jordan' },
    { code: 'LB', dialCode: '+961', flag: '🇱🇧', name: 'Lebanon' },
    { code: 'US', dialCode: '+1', flag: '🇺🇸', name: 'United States' },
    { code: 'GB', dialCode: '+44', flag: '🇬🇧', name: 'United Kingdom' },
    { code: 'IN', dialCode: '+91', flag: '🇮🇳', name: 'India' },
    { code: 'PK', dialCode: '+92', flag: '🇵🇰', name: 'Pakistan' },
    { code: 'BD', dialCode: '+880', flag: '🇧🇩', name: 'Bangladesh' },
    { code: 'TR', dialCode: '+90', flag: '🇹🇷', name: 'Turkey' },
    { code: 'FR', dialCode: '+33', flag: '🇫🇷', name: 'France' },
    { code: 'DE', dialCode: '+49', flag: '🇩🇪', name: 'Germany' },
    { code: 'IT', dialCode: '+39', flag: '🇮🇹', name: 'Italy' },
    { code: 'ES', dialCode: '+34', flag: '🇪🇸', name: 'Spain' },
    { code: 'CN', dialCode: '+86', flag: '🇨🇳', name: 'China' },
    { code: 'JP', dialCode: '+81', flag: '🇯🇵', name: 'Japan' },
    { code: 'KR', dialCode: '+82', flag: '🇰🇷', name: 'South Korea' },
    { code: 'AU', dialCode: '+61', flag: '🇦🇺', name: 'Australia' },
    { code: 'CA', dialCode: '+1', flag: '🇨🇦', name: 'Canada' },
    { code: 'BR', dialCode: '+55', flag: '🇧🇷', name: 'Brazil' },
    { code: 'MX', dialCode: '+52', flag: '🇲🇽', name: 'Mexico' },
    { code: 'RU', dialCode: '+7', flag: '🇷🇺', name: 'Russia' },
    { code: 'ZA', dialCode: '+27', flag: '🇿🇦', name: 'South Africa' },
    { code: 'NG', dialCode: '+234', flag: '🇳🇬', name: 'Nigeria' },
    { code: 'KE', dialCode: '+254', flag: '🇰🇪', name: 'Kenya' }
  ];

  sections = [
    {
      title: 'Juices',
      description: 'Experience pure refreshment with juices made from world’s best fruits.',
      bg: '#F0567A',
      nextBg: '#FFC033',
      textColor: '#ffffff',
      reverse: false,
      brands: ['assets/img/brands/brand7.png', 'assets/img/brands/brand11.png', 'assets/img/brands/brand3.png', 'assets/img/brands/brand13.png'],
      image: 'assets/img/products/juice.png'
    },
    {
      title: 'Dairy',
      description: 'Wholesome dairy goodness crafted to nourish your everyday life.',
      bg: '#FFC033',
      nextBg: '#09B384',
      textColor: '#1e1e1e',
      reverse: true,
      brands: ['assets/img/brands/brand7.png', 'assets/img/brands/brand4.png', 'assets/img/brands/brand14.png'],
      image: 'assets/img/products/dairy.png'
    },
    {
      title: 'Ice Cream',
      description: 'Whether it’s a scoop, a cone, or a stick - every moment becomes special with Unikai Ice Creams.',
      bg: '#09B384',
      nextBg: '#0A485D',
      textColor: '#ffffff',
      reverse: false,
      brands: ['assets/img/brands/brand7.png','assets/img/brands/brand11.png', 'assets/img/brands/brand8.png', 'assets/img/brands/brand1.png','assets/img/brands/brand5.png','assets/img/brands/brand10.png', 'assets/img/brands/brand9.png'],
      image: 'assets/img/products/ice-cream.png'
    },
    {
      title: 'Rice',
      description: 'For decades, Unikai has brought families the finest rice- from fragrant basmati to everyday favourites cherished across many regions.',
      bg: '#0A485D',
      nextBg: '#8FDBF5',
      textColor: '#ffffff',
      reverse: true,
      brands: ['assets/img/brands/brand12.png', 'assets/img/brands/brand11.png'],
      image: 'assets/img/products/rice.png'
    },
    {
      title: 'Foods',
      description: 'From ketchup to hot sauce, hazelnut spread to frozen food  and oil, your pantry essentials, all covered with our convenient food range.Your pantry essentials – sauces, oils and frozen foods.',
      bg: '#8FDBF5',
      nextBg: '#24356D',
      textColor: '#1e1e1e',
      reverse: false,
      brands: ['assets/img/brands/brand7.png', 'assets/img/brands/brand2.png', 'assets/img/brands/brand6.png'],
      image: 'assets/img/products/foods.png'
    },
    {
      title: 'Download Brochure',
      description: 'Get detailed insights about our products and services',
      bg: '#24356D',
      textColor: '#ffffff',
      type: 'brochure'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    // Set default to Saudi Arabia
    this.selectedCountry = this.countries.find(c => c.code === 'SA') || this.countries[0];
  }

  onCountryChange(country: Country): void {
    this.selectedCountry = country;
    this.showCountryDropdown = false;
  }

  toggleCountryDropdown(event: Event): void {
    event.stopPropagation();
    this.showCountryDropdown = !this.showCountryDropdown;
  }

  selectCountry(country: Country): void {
    this.selectedCountry = country;
    this.showCountryDropdown = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.country-selector')) {
      this.showCountryDropdown = false;
    }
    if (!target.closest('.country-form-selector')) {
      this.showCountryFormDropdown = false;
    }
  }

  getFullPhoneNumber(): string {
    return `${this.selectedCountry.dialCode}${this.mobileNumber}`;
  }

  toggleCountryFormDropdown(event: Event): void {
    event.stopPropagation();
    this.showCountryFormDropdown = !this.showCountryFormDropdown;
  }

  selectCountryForm(countryCode: string): void {
    this.selectedCountryForm = countryCode;
    this.showCountryFormDropdown = false;
  }

  getCountryName(code: string): string {
    const country = this.countries.find(c => c.code === code);
    return country ? country.name : 'Saudi Arabia';
  }

}